<ion-button [fill]="item.fill" (click)="item.click($event)" [disabled]="item.isDisabled" color="primary">
  <ion-icon [icon]="item.icon" [size]="size"></ion-icon>
  <span *ngIf="item.counter > 0" class="counter">{{ item.counter }}</span>
  <ion-icon *ngIf="item.attention" [name]="item.attention" size="small" color="danger" class="warning"></ion-icon>
</ion-button>
